/**
 * クライアント側プリファレンス。 LocalStorage に永続化。
 *
 * - focusPolicy: AutoOnOpponentMove (default) / Manual
 * - soundEnabled: 効果音 (駒音 + クロック警告)
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type FocusPolicy = 'AutoOnOpponentMove' | 'Manual';

interface PrefsState {
  focusPolicy: FocusPolicy;
  soundEnabled: boolean;
  /** 検討で候補手を盤に重ねる。 */
  showCandidates: boolean;
  setFocusPolicy: (p: FocusPolicy) => void;
  setSound: (v: boolean) => void;
  setShowCandidates: (v: boolean) => void;
}

export const usePrefs = create<PrefsState>()(
  persist(
    (set) => ({
      focusPolicy: 'AutoOnOpponentMove',
      // 効果音はデフォルト ON。 ユーザー指定 (2026-06-16)。
      // 既に false で永続化済みのユーザーは設定画面 / Play メニューから ON に切替可。
      soundEnabled: true,
      showCandidates: true,
      setFocusPolicy: (focusPolicy) => set({ focusPolicy }),
      setSound: (soundEnabled) => set({ soundEnabled }),
      setShowCandidates: (showCandidates) => set({ showCandidates }),
    }),
    { name: 'mixed-game-prefs' },
  ),
);
